import { library } from '@fortawesome/fontawesome-svg-core';
import { 
  faUserFriends, 
  faCommentAlt,
  faSearch,
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faUserFriends,
  faCommentAlt,
  faSearch,
); 